module.exports = __webpack_public_path__ + "media/src/images/zu_exp_04-8b7ab8028ca4cdc0bccf11792c3dc5a9.png";